import { UseSuspenseQueryOptions, useMutation, useQueryClient } from '@tanstack/react-query';

import { Id } from '@feature/utils';
import { Validation } from '@feature/validation';
import { generateValidationApi, generateValidationOptions } from '@feature/validation/validationGenerator';

const validationApi = generateValidationApi('/validation/doctoral-committee');

const { getHistoryOptions, validateOptions, getCurrentOptions } = generateValidationOptions(
  'doctoralCommittee',
  validationApi,
);

export function getDoctoralCommitteeValidationHistoryOptions(
  doctoralCommitteeId: Id,
): UseSuspenseQueryOptions<Validation[]> {
  return getHistoryOptions(doctoralCommitteeId);
}

export function getDoctoralCommitteeValidationOptions(
  doctoralCommitteeId: Id,
): UseSuspenseQueryOptions<Validation | null> {
  return getCurrentOptions(doctoralCommitteeId);
}

export function useValidateDoctoralCommittee(doctoralCommitteeId: Id) {
  const queryClient = useQueryClient();
  return useMutation(validateOptions(doctoralCommitteeId, queryClient));
}
